<template>
  <div class="geogrid-competitors-score">
    <div class="geogrid-competitors-score__head ">
      <h2 class="geogrid-competitors-score__title">Competitors</h2>
      <button class="geogrid-competitors-score__close btn btn-pretender" @click="$emit('close')">close<i class="fa-solid fa-xmark pl-2" /></button>

      <div
        v-if="geogrid.obfuscatedId"
        class="geogrid-competitors-score__current">
        <div class="geogrid-competitors-score__column geogrid-competitors-score__column--current geogrid-competitors-score__column--image" />
        <div class="geogrid-competitors-score__column geogrid-competitors-score__column--current geogrid-competitors-score__column--name">
          <p>Your company:</p>
          <span class="text-truncate">{{ current.name }}</span>
        </div>
        <div class="geogrid-competitors-score__column geogrid-competitors-score__column--current geogrid-competitors-score__column--agr">
          <p>AGR:</p>
          <span>{{ current.geogrid?.agr ?? 'N/A' }}</span>
        </div>
        <div class="geogrid-competitors-score__column geogrid-competitors-score__column--current geogrid-competitors-score__column--atgr">
          <p>ATGR:</p>
          <span>{{ current.geogrid?.atgr ?? 'N/A' }}</span>
        </div>
        <div class="geogrid-competitors-score__column geogrid-competitors-score__column--current geogrid-competitors-score__column--solv">
          <p>SoIV:</p>
          <span>{{ current.geogrid?.solv ? `${Math.round(current.geogrid.solv * 100)}%` : '0%' }}</span>
        </div>
        <div class="geogrid-competitors-score__column geogrid-competitors-score__column--current geogrid-competitors-score__column--rating">
          <p>Rating:</p>
          <span>{{ currentCompetitorLocation?.rating?.toFixed(1) ?? 'N/A' }}</span>
        </div>
      </div>
    </div>
    <div class="geogrid-competitors-score__list scroll ver hor">
      <VueSlimTable
        v-if="geogrid.obfuscatedId"
        ref="table"
        :source="loadCompetitors"
        :columns="columns"
        class="geogrid-competitors-score__table">
        <template #row="{ row }">
          <CompetitorScoreRow :row="row" />
        </template>
      </VueSlimTable>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import hotkeys from 'hotkeys-js'
import { mapState } from 'vuex'
import axiosTransform from '../../../common/axios'

import CompetitorScoreRow from './competitor_score_row'

export default {
  components: {
    CompetitorScoreRow
  },
  data: () => ({
    current: {},
    competitors: null,
    updateCompetitors: true
  }),
  created() {
    this.columns = [
      {
        title: '',
        key: 'imageSrc'
      },
      {
        title: 'Business',
        key: 'name'
      },
      {
        title: 'AGR',
        key: 'agr',
        orderable: true
      },
      {
        title: 'ATGR',
        key: 'atgr',
        orderable: true
      },
      {
        title: 'SolV',
        key: 'solv',
        orderable: true
      },
      {
        title: 'Rating'
      },
      {
        title: ''
      }
    ]
  },
  methods: {
    handleEsc(event, handler) {
      if (handler.key !== 'esc') {
        return
      }
      event.preventDefault()

      this.$emit('close')
    },
    async loadCompetitors(params) {
      const order = params?.order
      let sortBy = 'solv'
      let sortOrder = 'desc'
      if (order) {
        sortBy = order[0].field
        sortOrder = order[0].direction
      }

      const sortingFunction = (a, b) => {
        const direction = sortOrder === 'asc' ? 1 : -1
        return (a.geogrid[sortBy] - b.geogrid[sortBy]) * direction
      }

      if (this.updateCompetitors) {
        const { data: competitors } = await axios.get(`api/geogrids/${this.geogrid.obfuscatedId}/competitors_list`, {
          ...axiosTransform
        })

        this.competitors = competitors ?? []
        this.updateCompetitors = false
      }

      return this.competitors.sort(sortingFunction)
    }
  },
  computed: {
    ...mapState(['geogrid']),
    currentCompetitorLocation() {
      return this.competitors?.find((competitor) => competitor.yourCompany)
    }
  },
  mounted() {
    hotkeys('esc', this.handleEsc)
  },
  destroyed() {
    hotkeys.unbind('esc', this.handleEsc)
  },
  watch: {
    geogrid: {
      handler(newGeogrid) {
        if (!newGeogrid.obfuscatedId) {
          return
        }

        this.updateCompetitors = true
        this.$refs.table?.refetch()

        this.current = {
          name: this.geogrid.attrs.businessName,
          geogrid: {
            agr: this.geogrid.agr,
            atgr: this.geogrid.atgr,
            solv: this.geogrid.solv
          }
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
